/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
export default function Image({className, ...props}) {
  return (
    <img
        className= {props.fill ? "w-full "+ className  :  className  }
        {...props}
      />
  )
}
